// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .document-breadcrumb-container ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
:host ::ng-deep .document-breadcrumb-container li {
  border-left: 4px solid #589bbe;
  border-radius: 0px 7px 7px 0px;
  font-weight: 400;
  line-height: 30px;
  text-indent: 5px;
  padding: 0 5px 0 0;
  text-decoration: underline;
  font-size: 1rem;
  letter-spacing: 0.4px;
}
:host ::ng-deep .document-breadcrumb-container li a {
  color: #589bbe;
  cursor: pointer;
}
:host ::ng-deep .document-breadcrumb-container li:hover {
  bottom: 2px;
  box-shadow: 1px 1px 10px -2px #827e7e;
}
:host ::ng-deep .document-breadcrumb-container li.current {
  background: white;
  border-radius: 0px 7px 7px 0px;
  border-left: 4px solid #F44336;
  color: #003472;
  font-weight: 400;
  height: 30px;
}
:host ::ng-deep .document-breadcrumb-container li.current a {
  color: black;
}
:host ::ng-deep .document-breadcrumb-container .separator {
  margin: 0 2px;
}
:host ::ng-deep .document-breadcrumb-container .crumb {
  display: inline-flex;
  background-image: url("/assets/img/breadcrumb.svg");
  background-repeat: no-repeat;
  background-position: right center;
  height: 44px;
  background-size: auto 24px;
  flex: 0 0 auto;
  order: 1;
  padding-right: 7px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/document-breadcrumb/document-breadcrumb.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAAJ;AAGE;EAEE,8BAAA;EACA,8BAAA;EACA,gBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,kBAAA;EAGA,0BAAA;EACA,eAAA;EACA,qBAAA;AALJ;AAOI;EACE,cAAA;EACA,eAAA;AALN;AAQI;EACE,WAAA;EACA,qCAAA;AANN;AASI;EACE,iBAAA;EACA,8BAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAPN;AASM;EACE,YAAA;AAPR;AAYE;EACE,aAAA;AAVJ;AAoBE;EACE,oBAAA;EACA,mDAAA;EACA,4BAAA;EACA,iCAAA;EACA,YAAA;EACA,0BAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;AAlBJ;;AAqBA;EACE,kCAAA;AAlBF","sourcesContent":[":host ::ng-deep .document-breadcrumb-container {\r\n  ul {\r\n    display: flex;\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  li {\r\n    //background: #99cfef;\r\n    border-left: 4px solid #589bbe;\r\n    border-radius: 0px 7px 7px 0px;\r\n    font-weight: 400;\r\n   // margin-right: 5px;\r\n    line-height: 30px;\r\n    text-indent: 5px;\r\n    padding: 0 5px 0 0;\r\n\r\n   // position: relative;\r\n    text-decoration: underline;\r\n    font-size: 1rem;\r\n    letter-spacing: 0.4px;\r\n\r\n    a {\r\n      color: #589bbe;\r\n      cursor: pointer;\r\n    }\r\n\r\n    &:hover {\r\n      bottom: 2px;\r\n      box-shadow: 1px 1px 10px -2px #827e7e;\r\n    }\r\n\r\n    &.current {\r\n      background: white;\r\n      border-radius: 0px 7px 7px 0px;\r\n      border-left: 4px solid #F44336;\r\n      color: #003472;\r\n      font-weight: 400;\r\n      height: 30px;\r\n\r\n      a {\r\n        color: black;\r\n      }\r\n    }\r\n  }\r\n\r\n  .separator {\r\n    margin: 0 2px;\r\n  }\r\n\r\n  .textDisplay{\r\n    // width: 100%;\r\n    // text-overflow: ellipsis;\r\n    // overflow: hidden;\r\n    // white-space: pre;\r\n  }\r\n\r\n  .crumb{\r\n    display: inline-flex;\r\n    background-image: url('/assets/img/breadcrumb.svg');\r\n    background-repeat: no-repeat;\r\n    background-position: right center;\r\n    height: 44px;\r\n    background-size: auto 24px;\r\n    flex: 0 0 auto;\r\n    order: 1;\r\n    padding-right: 7px;\r\n  }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
